/**************************************************
 * Nombre:       Dashboard
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import DashboardBase from "../Modulo_Dashboard/Componentes/DashboardBase";
import React, {createContext, useContext, useEffect, useState} from "react";
import {BadgeOutlined, ChecklistOutlined, ContactEmergencyOutlined, DoorFrontOutlined} from "@mui/icons-material";
import {funSalir} from "../Servicios/Auth/funSalir";
import {usuarioContext} from "../App";
import Seccion_Administradores from "./Secciones/Seccion_Administradores";
import Seccion_Conductor from "./Secciones/Seccion_Conductor";
import Seccion_Listas_Checkeo from "./Secciones/Seccion_Listas_Checkeo";
import Seccion_Listas_Checkeo_Conductor from "./Secciones/Seccion_Listas_Checkeo_Conductor";


export const contexBarra = createContext()
const Dashboard = () => {
    const [notificaciones, setNotificaciones] = useState([])
    const [nuevasNotificaciones, setNuevasNotificaciones] = useState(0)
    const [historial, setHistorial] = useState([])
    const [nuevoHistorial, setNuevoHistorial] = useState(0)
    const {usuario} = useContext(usuarioContext)

    const [open, setOpen] = useState(false)
    const salir = () => {
        funSalir()
    }

    const valoresBarra = {
        notificaciones,
        nuevasNotificaciones,
        historial,
        nuevoHistorial,
        funSalir: salir

    }


    const {Provider} = contexBarra;


    useEffect(() => {


    }, [usuario]);
    return (
        <Grid
            container
            size={12}
        >


            <Provider value={valoresBarra}>
                <DashboardBase secciones={secciones} seccionesPerfil={seccionesPerfil} seccionesID={seccionesID}
                               usuario={usuario}/>
            </Provider>

        </Grid>
    )

}
export default Dashboard

const secciones = [

    {
        nombre: 'Listas de Checkeo',
        icono: ChecklistOutlined,
        camino: '/ListaCheck',
        categoria: 'Check List',
        Componente: <Seccion_Listas_Checkeo/>
    },
    {
        nombre: 'Conductores',
        icono: ContactEmergencyOutlined,
        camino: '/Conductores',
        categoria: 'Check List',
        Componente: <Seccion_Conductor/>
    },
    {
        nombre: 'Administradores',
        icono: BadgeOutlined,
        camino: '/Administradores',
        categoria: 'Configuraciones',
        privada: true,
        Componente: <Seccion_Administradores/>
    }
]

const seccionesID = [
    {
        nombre: 'Listas de Checkeo',
        camino: '/listaConductor/:id',
        Componente: <Seccion_Listas_Checkeo_Conductor/>
    }

]

const seccionesPerfil = []

const notificaciones = {}